import Model, { attr, hasMany } from '@ember-data/model';
import type { SyncHasMany } from '@ember-data/model';
import type CustomUserDocumentTemplateModel from 'garaje/models/custom-user-document-template';

export default class DocumentUploadPageModel extends Model {
  @attr('boolean', { defaultValue: false }) declare enabled: boolean;
  @attr('number') declare position: number | undefined;

  @hasMany('custom-user-document-template', { async: false, inverse: null })
  declare customUserDocumentTemplates: SyncHasMany<CustomUserDocumentTemplateModel>;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'document-upload-page': DocumentUploadPageModel;
  }
}
